/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './common';
import './onboarding';
import '../spos/debitcard_management/atm_limits/debitcard_atm_limits';
import './ui_element';
import './unit_notification_preferences';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "ScreenContainer": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "logEvent": {
                        "type": "squareup.bbfrontend.service.v1.LogEvent",
                        "id": 2,
                        "rule": "optional"
                      },
                      "header": {
                        "type": "squareup.bbfrontend.service.v1.ScreenHeader",
                        "id": 3,
                        "rule": "optional"
                      },
                      "formScreen": {
                        "type": "squareup.bbfrontend.service.v1.ScreenContainer.FormScreen",
                        "id": 4
                      },
                      "completionStatusScreen": {
                        "type": "squareup.bbfrontend.service.v1.ScreenContainer.CompletionStatusScreen",
                        "id": 5
                      },
                      "unitNotificationPreferencesScreen": {
                        "type": "squareup.bbfrontend.service.v1.ScreenContainer.UnitNotificationPreferencesScreen",
                        "id": 6
                      },
                      "onboardingScreen": {
                        "type": "squareup.bbfrontend.service.v1.OnboardingScreen",
                        "id": 7
                      },
                      "atmLimitsScreen": {
                        "type": "squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimitsScreen",
                        "id": 8
                      }
                    },
                    "nested": {
                      "FormScreen": {
                        "fields": {
                          "content": {
                            "type": "squareup.bbfrontend.service.v1.UiElement",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CompletionStatusScreen": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "glyph": {
                            "type": "squareup.bbfrontend.service.v1.ScreenContainer.CompletionStatusScreen.StatusGlyph",
                            "id": 2,
                            "rule": "optional"
                          },
                          "title": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "message": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "completionButton": {
                            "type": "squareup.bbfrontend.service.v1.UiElement.ButtonElement",
                            "id": 5,
                            "rule": "optional"
                          },
                          "automaticDismissalBehavior": {
                            "type": "squareup.bbfrontend.service.v1.ScreenContainer.CompletionStatusScreen.AutomaticDismissalBehavior",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "AutomaticDismissalBehavior": {
                            "fields": {
                              "millisecondDelay": {
                                "type": "double",
                                "id": 1,
                                "rule": "optional",
                                "options": {
                                  "default": 1000.0
                                }
                              }
                            }
                          },
                          "StatusGlyph": {
                            "values": {
                              "STATUS_GLYPH_DO_NOT_USE": 0,
                              "SUCCESS": 1,
                              "FAILURE": 2
                            }
                          }
                        }
                      },
                      "UnitNotificationPreferencesScreen": {
                        "fields": {
                          "preferences": {
                            "type": "squareup.bbfrontend.service.v1.UnitNotificationPreferences",
                            "id": 1,
                            "rule": "optional"
                          },
                          "banners": {
                            "type": "squareup.bbfrontend.service.v1.UiElement.BannerElement",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "saveButton": {
                            "type": "squareup.bbfrontend.service.v1.UiElement.ButtonElement",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "child": {
                        "oneof": ["formScreen", "completionStatusScreen", "unitNotificationPreferencesScreen", "onboardingScreen", "atmLimitsScreen"]
                      }
                    }
                  },
                  "Toast": {
                    "fields": {
                      "style": {
                        "type": "squareup.bbfrontend.service.v1.Toast.Style",
                        "id": 1,
                        "rule": "optional"
                      },
                      "text": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "automaticDismissalTimeout": {
                        "type": "double",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": 2000.0
                        }
                      }
                    },
                    "nested": {
                      "Style": {
                        "values": {
                          "INFO": 0,
                          "SUCCESS": 1,
                          "WARNING": 2,
                          "CRITICAL": 3,
                          "INSIGHT": 4
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenContainer && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenContainer?.nested?.FormScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenContainer?.nested?.CompletionStatusScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenContainer?.nested?.CompletionStatusScreen?.nested?.AutomaticDismissalBehavior && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenContainer?.nested?.CompletionStatusScreen?.nested?.StatusGlyph && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenContainer?.nested?.UnitNotificationPreferencesScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Toast && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Toast?.nested?.Style) {
  $root.addJSON(jsonData);
}

/**
 * Screen container represents the page that the clients would display. The screen container will
 * host [UiElement]s that are necessary to render the UI screen.
 *
 * SOURCE ScreenContainer @ squareup/bbfrontend/v1/model.proto at 20:1
 */
export const ScreenContainer = $root.lookupType('squareup.bbfrontend.service.v1.ScreenContainer');
fixType(ScreenContainer, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ScreenContainer);
/**
 * SOURCE FormScreen @ squareup/bbfrontend/v1/model.proto at 44:3
 */
ScreenContainer.FormScreen = $root.lookupType('squareup.bbfrontend.service.v1.ScreenContainer.FormScreen');
fixType(ScreenContainer.FormScreen);
Builder.createAndAttachToType(ScreenContainer.FormScreen);
/**
 * SOURCE CompletionStatusScreen @ squareup/bbfrontend/v1/model.proto at 52:3
 */
ScreenContainer.CompletionStatusScreen = $root.lookupType('squareup.bbfrontend.service.v1.ScreenContainer.CompletionStatusScreen');
fixType(ScreenContainer.CompletionStatusScreen, {
  id: {
    required: true
  },
  glyph: {
    required: true
  },
  title: {
    required: true
  },
  completionButton: {
    required: true
  }
});
Builder.createAndAttachToType(ScreenContainer.CompletionStatusScreen);
/**
 * SOURCE AutomaticDismissalBehavior @ squareup/bbfrontend/v1/model.proto at 69:5
 */
ScreenContainer.CompletionStatusScreen.AutomaticDismissalBehavior = $root.lookupType('squareup.bbfrontend.service.v1.ScreenContainer.CompletionStatusScreen.AutomaticDismissalBehavior');
fixType(ScreenContainer.CompletionStatusScreen.AutomaticDismissalBehavior);
Builder.createAndAttachToType(ScreenContainer.CompletionStatusScreen.AutomaticDismissalBehavior);
/**
 * SOURCE StatusGlyph @ squareup/bbfrontend/v1/model.proto at 78:5
 */
ScreenContainer.CompletionStatusScreen.StatusGlyph = $root.lookupEnum('squareup.bbfrontend.service.v1.ScreenContainer.CompletionStatusScreen.StatusGlyph').values;
/**
 * SOURCE UnitNotificationPreferencesScreen @ squareup/bbfrontend/v1/model.proto at 85:3
 */
ScreenContainer.UnitNotificationPreferencesScreen = $root.lookupType('squareup.bbfrontend.service.v1.ScreenContainer.UnitNotificationPreferencesScreen');
fixType(ScreenContainer.UnitNotificationPreferencesScreen, {
  preferences: {
    required: true
  }
});
Builder.createAndAttachToType(ScreenContainer.UnitNotificationPreferencesScreen);
/**
 * Used to show a toast at the bottom of the screen. Toasts in general are short messages and
 * auto dismissing.
 *
 * SOURCE Toast @ squareup/bbfrontend/v1/model.proto at 96:1
 */
export const Toast = $root.lookupType('squareup.bbfrontend.service.v1.Toast');
fixType(Toast);
Builder.createAndAttachToType(Toast);
/**
 * SOURCE Style @ squareup/bbfrontend/v1/model.proto at 103:3
 */
Toast.Style = $root.lookupEnum('squareup.bbfrontend.service.v1.Toast.Style').values;